<template>
   <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
     
  <div class="col-span-full lg:col-span-12 card">
             
 <div class="flex flex-col md:flex-row gap-4">
    <div class="w-full p-2 lg:p-3 xl:p-4 rounded-15 bg-[#F2ECFF] dark:bg-dark-card-two dk-theme-card-square">
      <router-link to="/customerlist">
        <div class="flex items-center gap-3">
            <div class="before:font-remix before:text-2xl before:text-primary-500 before:content-['\f3e9']"></div>
            <h6 class="text-base lg:text-sm xl:text-base font-semibold text-heading">All Members</h6>
        </div>
        <div class="flex-center-between mt-2">
            <span class="text-2xl lg:text-2xl xl:text-2xl font-bold text-[#323232] dark:text-dark-text">{{total_member_counts}}</span> 
        </div>
      </router-link>
    </div> 
    <div class="w-full p-2 lg:p-3 xl:p-4 rounded-15 bg-[#F2ECFF] dark:bg-dark-card-two dk-theme-card-square">
      <router-link to="/stafflist">
        <div class="flex items-center gap-3">
            <div class="before:font-remix before:text-2xl before:text-primary-500 before:content-['\f3e9']"></div>
            <h6 class="text-base lg:text-sm xl:text-base font-semibold text-heading">All Staff</h6>
        </div>
        <div class="flex-center-between mt-2">
            <span class="text-2xl lg:text-2xl xl:text-2xl font-bold text-[#323232] dark:text-dark-text">{{total_staff_counts}}</span> 
        </div>
      </router-link>
    </div> 
    <div class="w-full p-2 lg:p-3 xl:p-4 rounded-15 bg-[#F2ECFF] dark:bg-dark-card-two dk-theme-card-square" v-show="userRole === '1'">
        
      <router-link to="/totalincome">
        <div class="flex items-center gap-3">
            <div class="before:font-remix before:text-2xl before:text-primary-500 before:content-['\f3e9']"></div>
            <h6 class="text-base lg:text-sm xl:text-base font-semibold text-heading">Income</h6>
        </div>
        <div class="flex-center-between mt-2">
            <span class="text-2xl lg:text-2xl xl:text-2xl font-bold text-[#323232] dark:text-dark-text">{{total_income}}</span> 
        </div>
      </router-link>
    </div> 
    <div class="w-full p-2 lg:p-3 xl:p-4 rounded-15 bg-[#F2ECFF] dark:bg-dark-card-two dk-theme-card-square">
                          <router-link to="/totaldue">
        <div class="flex items-center gap-3">
            <div class="before:font-remix before:text-2xl before:text-primary-500 before:content-['\f3e9']"></div>
            <h6 class="text-base lg:text-sm xl:text-base font-semibold text-heading">Outstanding</h6>
        </div>
        <div class="flex-center-between mt-2">
            <span class="text-2xl lg:text-2xl xl:text-2xl font-bold text-[#323232] dark:text-dark-text">{{total_due_amount}}</span> 
        </div>
    </router-link>
    </div> 
    <div class="w-full p-2 lg:p-3 xl:p-4 rounded-15 bg-[#F2ECFF] dark:bg-dark-card-two dk-theme-card-square">
          <router-link :to="'/subscriptionlist/todaysexpiry'">
            <div class="flex items-center gap-3">
                <div class="before:font-remix before:text-2xl before:text-primary-500 before:content-['\f3e9']"></div>
                <h6 class="text-base lg:text-sm xl:text-base font-semibold text-heading">Todays Expiry</h6>
            </div>
            <div class="flex-center-between mt-2">
                <span class="text-2xl lg:text-2xl xl:text-2xl font-bold text-[#323232] dark:text-dark-text">{{todays_expiry_count}}</span> 
            </div>
    </router-link>
        </div> 
</div>
</div>

          <!--<div class="grid grid-cols-12 gap-x-4">
                <div class="flex-center-between">
                    <h6 class="card-title text-lg leading-none">Gym Overview</h6>
                    <div class="leading-none shrink-0 text-xs text-gray-500 dark:text-dark-text dk-border-one rounded-full px-2 py-1 dk-theme-card-square">07 Days</div>
                </div>
                <div class="flex flex-col h-full">
                    <div id="analytic-device-session-chart" class="flex-center grow"></div>
                    <div class="flex-center-between py-5">
                        <div class="card bg-danger text-center">
                          <router-link to="/customerlist">
                            <div class="card-title"> 
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                          <path stroke-linecap="round" stroke-linejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
                                        </svg>
                                        Members</div>
                            <div class="text-gray-500 dark:text-dark-text-two font-semibold">{{total_member_counts}}</div>
                          </router-link>
                        </div>
                        <div>
                          <router-link to="/stafflist">
                            <div class="card-title text-base"> <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
</svg>
 Staff</div>
                            <div class="text-gray-500 dark:text-dark-text-two font-semibold">{{total_staff_counts}}</div>
                          </router-link>
                        </div>
                        <div>
                          <router-link to="/totalincome">
                            <div class="card-title text-base"> <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z" />
</svg>
 Income</div>
                            <div class="text-gray-500 dark:text-dark-text-two font-semibold">{{total_income}}</div>
                          </router-link>
                        </div>
                        <div>
                          <router-link to="/totaldue">
                            <div class="card-title text-base"> <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" />
</svg>
 Due</div>
                            <div class="text-gray-500 dark:text-dark-text-two font-semibold">{{total_due_amount}}</div>
                          </router-link>
                        </div>
                        <div>
                          <router-link to="/todaysfollowup/today">
                          <div class="card-title text-base"> <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
</svg>
 Todays Followup</div>
                          <div class="text-gray-500 dark:text-dark-text-two font-semibold">{{todays_followup_count}}</div>
                        </router-link>
                      </div>
                      <div>
                        <router-link :to="'/subscriptionlist/todaysexpiry'">
                        <div class="card-title text-base"> <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
</svg>
 Todays Expiry</div>
                        <div class="text-gray-500 dark:text-dark-text-two font-semibold">{{todays_expiry_count}}</div>
                      </router-link>
                    </div>
                       
                    </div>
                </div>
            </div>
           End User By Device Section -->

       
           <div class="col-span-full lg:col-span-12 card p-0">
              <!-- INITIALIZE CSS CLASS -->
              <div class="hidden">
                  <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                  <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                  <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                  <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                  <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
              </div>
              <!-- INITIALIZE CSS CLASS -->
              <div class="tablejs sr-only size-0"></div>
              <!-- BASIC DATA TABLE -->
              <div class="col-span-full">
                  <div class="card p-0">
                    <div class="card">
                      <h6 class="card-title">Today's Birthday</h6>
                  </div>
                      <div class="p-6  ">
                          <table id="basicDataTable" class="datatable">
                              <thead>
                                  <tr>
                                      <th class="bg-[#B2E8D9]">Member Name</th>
                                      <th class="bg-[#B2E8D9]">Contact No</th>
                                      <th class="bg-[#B2E8D9]">Date Of Birth</th>
                                  </tr>
                              </thead>
                              <tbody class="divide-y divide-gray-200 dark:divide-dark-border"> 
                                 <tr v-for="(item ,index)  in bdaylist" :key="item.id">
                                      <td>{{item.member_name}}</td>
                                      <td>{{item.phonenumber}}</td>
                                      <td>{{item.dob}}</td>
                                  </tr> 
                              </tbody>
                          </table>
                      </div>
                       
                      <!-- Prism Code -->
                      <div class="p-6 hidden">
                          <pre>
                              <code class="language-markup">
                                  &lt;p>Sorry we can't show the huge data table&lt;/p>
                              </code>
                          </pre>
                      </div>
                      <!-- Prism Code -->
                  </div>
              </div> 
              

            
        </div>
 

            <!-- Start Social Media Traffic Table -->
           
            <!-- End Chat Inbox -->
 <div class="col-span-full lg:col-span-12 card p-0">
              <!-- INITIALIZE CSS CLASS -->
              <div class="hidden">
                  <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                  <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                  <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                  <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                  <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
              </div>
              <!-- INITIALIZE CSS CLASS -->
              <div class="tablejs sr-only size-0"></div>
              <!-- BASIC DATA TABLE -->
              <div class="col-span-full">
                  <div class="card p-0">
                    <div class="card">
                      <h6 class="card-title">Followup List</h6>
                  </div>
                      <div class="p-6  ">
                          <table id="basicDataTable" class="datatable">
                              <thead>
                                  <tr>
                                      <th class="bg-[#B2E8D9]">Last Followup</th>
                                      <th class="bg-[#B2E8D9]">Name</th>
                                      <th class="bg-[#B2E8D9]">Contact No</th>
                                      <!-- <th class="bg-[#B2E8D9]">Cost</th> -->
                                      
                                      <th class="bg-[#B2E8D9]">Address</th>
                                      <th class="bg-[#B2E8D9]">Gender</th>
                                      <th class="bg-[#B2E8D9]">Remark</th>
                                      <th class="bg-[#B2E8D9]">NextDate</th>
                                      <th class="bg-[#B2E8D9]">Action</th>
                                      
                                  </tr>
                              </thead>
                              <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                  <tr v-for="(item ,index)  in leadlist" :key="item.id">
                                    <td>{{item.iddate}}</td>
                                      <td>{{item.name}}</td>
                                      <td>{{item.contact}}</td>
                                      <td>{{item.address}}</td>
                                      <td>{{item.gender}}</td>
                                      <td>{{item.remark}}</td>
                                      <td>{{item.nextfollowupdate}}</td>
                                      <td class="px-3.5 py-4">
                                          <div class="flex items-center gap-1">
                                              <button class="btn-icon btn-primary-icon-light size-7"  @click="editModal(item)"  >
                                                  <i class="ri-add-line text-danger text-[13px]"></i>
                                              </button>
                                          </div>
                                      </td>
                                  </tr> 
                              </tbody>
                          </table>
                      </div>
                      
                  
                      
                      
                      
                      
                      
                                            

                      <!-- Prism Code -->
                      <div class="p-6 hidden">
                          <pre>
                              <code class="language-markup">
                                  &lt;p>Sorry we can't show the huge data table&lt;/p>
                              </code>
                          </pre>
                      </div>
                      <!-- Prism Code -->
                  </div>
              </div>
              <!-- BORDERED SELECTION DELETION DATA TABLE -->
              

            
        </div>
        <div class="col-span-full lg:col-span-12 card"> 
            <div>
                     <h6 class="card-title">Monthly Report</h6>
                        <div class="overflow-x-auto">
                          <table class="table-auto border-collapse border border-gray-300 min-w-max">
                            <thead>
                              <tr class="bg-gray-200">
                                <!-- "Days" label as the first header -->
                                <th class="border border-gray-300 px-4 py-2 text-center">Days</th>
                                <!-- Render each day number in the header row -->
                                <th v-for="dayData in daysInMonth" :key="'day-header-' + dayData.day" class="border border-gray-300 px-4 py-2 text-center">
                                  {{ dayData.day }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="border border-gray-300 px-4 py-2 text-center font-bold">Lead</td>
                                <td v-for="dayData in daysInMonth" :key="'count-' + dayData.day" class="border border-gray-300 px-4 py-2 text-center">
                                  {{ dayData.count }}
                                </td>
                              </tr>
                              <tr>
                                <td class="border border-gray-300 px-4 py-2 text-center font-bold">subscription</td>
                                <td v-for="dayData in daysInMonth2" :key="'count-' + dayData.day" class="border border-gray-300 px-4 py-2 text-center">
                                  {{ dayData.count }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
           </div>             
                      
                      
    </div>

    <div id="editModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="background: #00000052;">
      <div class="p-4 w-full max-w-lg max-h-full">
        <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square max-h-full overflow-y-auto">
          <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
            <i class="ri-close-line text-inherit text-xl leading-none"></i>
          </button>
          <div class="p-4 md:p-5">
            
  
             <!-- start show data ---------------------------------------------------------------------------------------->
              <!-- start table here -->
        <div class="p-4 md:p-5">
          <table class="min-w-full table-auto">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Entry Date</th>
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Remark</th>
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Next Date</th>
              </tr>
            </thead>
            <tbody>
               <tr v-for="item in followup_list" :key="item.id" class="bg-white"> 
                
                <!-- <tr v-for="(item ,index)  in leadlists" :key="item.id"> -->
                <td class="px-4 py-2 text-sm text-gray-900">{{item.iddate}}</td>
                <td class="px-4 py-2 text-sm text-gray-900">{{item.remark}}</td>
                <td class="px-4 py-2 text-sm text-gray-900">{{item.nextdate}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- end table -->
  
              <!-- end show data --------------------------------------------------------------------------------------------------->
  
  
  
            <div class="mt-7">
              <label for="tagname" class="form-label">Next Date *</label>
              <input type="date" v-model="leads.nextdate" class="form-input" id="first_input" autocomplete="off" required>
            </div>
    
            <div class="mt-7">
              <label for="tagname" class="form-label">Remark *</label>
              <input type="text" v-model="leads.remark" class="form-input" id="first_input" placeholder="Remark" autocomplete="off" required>
            </div>
    
            <div class="flex justify-end mt-7">
              <button @click="save_followup" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<style>
  th, td {
    text-align: center;
    padding: 0.5rem;
  }
  th {
    font-weight: bold;
    background-color: #f3f4f6;
  }
  table {
    margin-top: 1rem;
    border-collapse: collapse;
    width: 100%;
  }

   .day {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem;
    margin: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 0.5rem;
    width: 70px;
  }
  .day-number {
    font-weight: bold;
    font-size: 1.2rem;
  }
  .lead-count {
    margin-top: 0.5rem;
    font-size: 1rem;
  }
    input:focus{
        background: gold !important;
    } 
    #days-container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 10px;
}

/* .day {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 4px;
} */
</style>
<!-- <meta name="csrf-token" content="{{ csrf_token() }}"> -->
<script>
    import axios from 'axios';
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView',
  components: {
    HelloWorld
  },
  created() {
    console.log('Component Created Hook Called');
  },
  mounted() {
    // this.getBasicsData();
    // this.getLeadData();
    this.getBasics();
    this.fetchLeadCounts();
    // this.fetchSubscriptionCounts();
  },
  data() {
    return {
      total_staff_counts: 0,
      userRole: localStorage.getItem('userRole'),
      total_member_counts: 0,
      total_income: 0,
      total_due_amount: 0 ,
      todays_followup_count: 0,
      todays_expiry_count: 0,
      followup_list:[],
     leadlist:[],
     currentMonth: new Date().getMonth(), // Current month (0-11)
      currentYear: new Date().getFullYear(), // Current year
      daysInMonth: [], 
      daysInMonth2: [], 
     leads:{
        nextdate:'',
        remark:'',
        lead_id:0,

    },
    bdaylist:[]
    };
  },
  computed: {
    // Get the month name for display
    monthName() {
      return new Date(this.currentYear, this.currentMonth).toLocaleString("default", { month: "long" });
    },
    // Dynamically calculate days in the current month
    daysInMonthCount() {
      return new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
    },
  },
  methods: {
    getTodayDate() {
                    const today = new Date();
                    const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
                    const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                    const dateTime = date +' '+ time;
                    this.timestamp = dateTime;
                },
    // Fetch lead counts from the backend API
    async fetchLeadCounts() {
  try {
    const response = await axios.post("leadCount", {
      year: this.currentYear,
      month: this.currentMonth + 1, // Adjust for 1-based month in server query
    });

    const leadData = response.data.leadCount || []; // Default to an empty array if undefined
    const leadData2 = response.data.subscriptionCount || []; // Default to an empty array if undefined
    console.log("Lead Data from API:", leadData); // Debugging log

    // Create a map with day as the key for easy lookup
    const leadCountMap = leadData.reduce((map, item) => {
      map[item.day] = item.count;
      return map;
    }, {});

    const leadCountMap2 = leadData2.reduce((map, item) => {
      map[item.day] = item.count;
      return map;
    }, {});

    // Prepare daysInMonth array with both day and count
    this.daysInMonth = Array.from({ length: this.daysInMonthCount }, (_, i) => {
      const day = i + 1;
      return { day, count: leadCountMap[day] || 0 }; // Default count is 0 if no leads
    });

    this.daysInMonth2 = Array.from({ length: this.daysInMonthCount }, (_, i) => {
      const day = i + 1;
      return { day, count: leadCountMap2[day] || 0 }; // Default count is 0 if no leads
    });

    console.log("Days in Month with Counts:", this.daysInMonth); // Debugging log
  } catch (error) {
    console.error("Error fetching lead counts:", error);
  }
}
,
    // async fetchSubscriptionCounts() {
    //   try {
    //     const response = await axios.post("subscriptionCount", {
    //       year: this.currentYear,
    //       month: this.currentMonth + 1, // Adjust for 1-based month in server query
    //     });

    //     const leadData = response.data;
    //     console.log("Lead Data from API:", leadData); // Debugging log

    //     // Create a map with day as the key for easy lookup
    //     const leadCountMap = leadData.reduce((map, item) => {
    //       map[item.day] = item.count;
    //       return map;
    //     }, {});

    //     // Prepare daysInMonth array with both day and count
    //     this.daysInMonth2 = Array.from({ length: this.daysInMonthCount }, (_, i) => {
    //       const day = i + 1;
    //       return { day, count: leadCountMap[day] || 0 }; // Default count is 0 if no leads
    //     });

    //     console.log("Days in Month with Counts:", this.daysInMonth2); // Debugging log
    //   } catch (error) {
    //     console.error("Error fetching lead counts:", error);
    //   }
    // },
    closeModal(){
     
     $("#editModal").addClass('hidden');
             $("#deleteModal").addClass('hidden');
         this.isAdd=0;
         this.isEdit=0;
         this.isDelete=0;
         this.deleteId=0;
         
  },
    editModal(item){
     if(item){
      var self = this; 
        this.leads.lead_id=item.id;
        axios.post('getleadbyid',{leadeid:item.id}).then(function (response) {
                  self.followup_list=response.data.followup_list;
                  console.log(self.followup_list);
                  self.employees=response.data.userDetails;
                  self.leads.nextdate=response.data.today;
                }).then(()=>{ 
                    // self.datatable= $(".datatable").DataTable({
                    //         "paging": true,
                    //         "ordering": true,  
                    //         "autoWidth": false });
              
                    });;

                 


     }
     if(!this.isEdit)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },
 save_followup() {
             var self = this; 
             axios.post('addfollowup', this.leads)
                 .then(response => {
                     var msg = response.data.msg;
                     var isSuccess = response.data.status;
                     self.followup_list=response.data.todays_followup; 
                     self.getBasics();
                     self.closeModal();
                    //  self.cat={name:'',status:'Active'};

                     //self.$swal(msg);
                    //  if (isSuccess == 1) {
                    //      self.closeModal();
                    //  }
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },
    
    // async getBasicsData() {
    //   try {
    //     const response = await axios.post('getallcount');
    //     this.total_staff_counts = response.data.total_staff_count;
    //     this.total_member_counts = response.data.total_member_count;
    //     this.total_income = response.data.totalIncome;
    //     this.total_due_amount = response.data.totalDueAmount;
    //     this.todays_followup_count = response.data.todaysfollowupcount;
    //     this.todays_expiry_count = response.data.todaysexpirycount;
    //   } catch (error) {
    //     console.error("There was an error fetching the staff count:", error);
    //   }
    // },
    // Revanasiddha Malage-12-11-2024
    async getBasics() {
      if ($.fn.dataTable.isDataTable('.datatable')) {
        $('.datatable').DataTable().destroy(); // Destroy existing instance
    } 
       var self=this;
       let type = 'todays';
         axios.post(`followuplist/${type}`).then(function (response) {
                  self.followup_list=response.data.todays_followup;
                  self.leadlist=response.data.todays_followup;
                  self.employees=response.data.userDetails;
                  self.total_staff_counts = response.data.total_staff_count;
                  self.total_member_counts = response.data.total_member_count;
                  self.total_income = response.data.totalIncome;
                  self.total_due_amount = response.data.totalDueAmount;
                  self.todays_followup_count = response.data.todaysfollowupcount;
                  self.todays_expiry_count = response.data.todaysexpirycount;
                  self.bdaylist= response.data.bdaylist;
                }).then(()=>{ 
                    self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false,
                            dom: 'Bfrtip', 
                            buttons: [
                              {
                                extend: 'excelHtml5',
                                title: 'Excel',
                              },
                            ], 
                          });
              
                    });
  },
  // async getLeadData() {
  //      var self=this;
  //      let type = 'report';
  //        axios.post(`followuplist/${type}`).then(function (response) {
  //                 self.leadlist=response.data.todays_followup;
  //                 self.employees=response.data.userDetails;
  //               }).then(()=>{ 
  //                   self.datatable= $(".datatable").DataTable({
  //                           "paging": true,
  //                           "ordering": true,  
  //                           "autoWidth": false });
              
  //                   });
  // }
  },

}
</script>
